import { countries } from '@noths/polaris-client-localisation';
import type { DropDownOption } from '@noths/polaris-client-ribbons-design-system';

import { currencies } from 'client-site-chrome-ui/content/currencies';

const COUNTRY_VALUE_SEPARATOR = '|';

export const encodeCountryValue = ({
  countryCode,
  countryName,
  deliveryZone,
}: {
  countryCode: string;
  countryName: string;
  deliveryZone: string;
}) => [countryName, countryCode, deliveryZone].join(COUNTRY_VALUE_SEPARATOR);

export const decodeCountryValue = (value: string) => {
  const [countryName, countryCode, deliveryZone] = value.split(COUNTRY_VALUE_SEPARATOR);

  return {
    countryName,
    countryCode,
    deliveryZone,
  };
};

const transformCountryToDropDownOption = ({
  countryCode,
  deliveryZoneCode,
  name,
}: {
  countryCode: string;
  deliveryZoneCode: string;
  name: string;
}): DropDownOption => ({
  optionValue: encodeCountryValue({
    countryName: name,
    countryCode,
    deliveryZone: deliveryZoneCode,
  }),
  optionLabel: name,
});

const transformCurrencyToDropDownOption = ({
  code,
  symbol,
}: {
  code: string;
  symbol: string;
}): DropDownOption => ({
  optionValue: code,
  optionLabel: `${symbol} ${code}`,
});

const getPlaceholderOption = (optionLabel: string): DropDownOption => ({
  optionValue: '',
  optionLabel,
  disabled: true,
});

export const countryOptions = [
  getPlaceholderOption('Select country'),
  ...countries.map(transformCountryToDropDownOption),
];

export const currencyOptions = [
  getPlaceholderOption('Select currency'),
  ...currencies.map(transformCurrencyToDropDownOption),
];
